var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9809 17.375L22.8141 11.9457H17.6045V8.42246C17.6045 6.93711 18.3322 5.48926 20.6654 5.48926H23.0338V0.866797C23.0338 0.866797 20.8846 0.5 18.8297 0.5C14.5395 0.5 11.7352 3.10039 11.7352 7.80781V11.9457H6.96622V17.375H11.7352V30.5H17.6045V17.375H21.9809Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook_.723be906fa2517292c6881d509dc89f7.svg";
export { ForwardRef as ReactComponent };